
export const getBidMultipliersEditorStyle = (iconFontFamily = 'MsAds MDL2 Assets') => ({
  '& ul': {
    listStyle: 'none',
    margin: 0,
    '& li': {
      float: 'left',
      '& .btn': {
        border: '1px solid #dcdcdc',
        height: 32,
        lineHeight: '28px',
        backgroundColor: 'transparent',
      },
    },

    '& .ui-tabs-selected': {
      backgroundColor: '#EFF6FC',
    },
  },

  '& .glyphicon-remove': {
    color: '#0078d4',
    fontFamily: iconFontFamily,
  },

  '& .glyphicon-remove:before': {
    content: '"\\E711"',
  },

  '& .bid-multipliers-content': {
    margin: 0,
    marginTop: '10px !important',
    '& .control-label': {
      paddingTop: 0,
      textAlign: 'left',
    },
    '& .form-group ': {
      marginBottom: 8,
      display: 'flex',
      flexWrap: 'wrap',
      '& .control-label': {
        width: '100%',
      },
      '& .form-control[readonly]': {
        background: '#f3f2f1',
        borderColor: '#f3f2f1',
        color: '#a19f9d',
        '& + .input-group-addon': {
          borderColor: '#f3f2f1',
        },
      },
    },
    '& .mulitpliers-query-add': {
      '& .col-sm-offset-5': {
        marginLeft: 0,
        paddingLeft: 0,
      },
      '& .col-sm-6': {
        width: '70%',
      },
    },
    '& .col-sm-4': {
      paddingLeft: 0,
      paddingRight: 8,
      width: '45%',
    },
    '& .form-control': {
      width: '100%',
    },
    '& .mulitpliers-query-add, .length-of-stay-multiplier': {
      '& .col-sm-1': {
        height: 32,
        lineHeight: '28px',
        textAlign: 'left',
        padding: 0,
      },
      '& .col-sm-11': {
        padding: 0,
      },
    },
    '& .col-sm-11 .col-sm-4:last-of-type': {
      padding: 0,
    },
    '& .col-sm-1.mulitplier-query-remove': {
      paddingTop: 6,
      paddingLeft: 2,
    },
    '& .user-country-multiplier': {
      '& .col-sm-11': {
        paddingLeft: 0,
      },
      '& .mulitplier-query-remove': {
        alignSelf: 'flex-end',
        marginBottom: 15,
      },
    },
    '& .length-of-stay-multiplier': {
      '& .mulitplier-query-remove': {
        alignSelf: 'flex-end',
        marginBottom: 8,
      },
    },
  },

  '& .edit-panel': {
    paddingLeft: 15,
  },

  '& .bid-multipliers-panel': {
    '& .col-sm-12': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },

  '& .form-group ': {
    margin: 0,
    '& .edit-panel': {
      paddingLeft: 0,
      paddingRight: 0,
      marginTop: 8,
    },
  },
});

export const getBidEditorStyle = () => ({
  '& .control-label': {
    paddingTop: 0,
  },
  '& .form-group': {
    margin: 0,
  },

  '& .col-sm-7, .col-sm-3, .col-sm-4, .col-sm-8': {
    width: 'auto',
    float: 'none',
    textAlign: 'left',
  },

  '& .bid-strategy-panel': {
    '& .radio': {
      display: 'block',
    },
    '& .input-group': {
      marginLeft: 8,
    },
  },
  '& .edit-panel': {
    marginTop: 12,
  },
});
